import {combineReducers} from 'redux';
import contrast from './contrast.js';

const reducers = combineReducers({
  contrast
});

export default reducers;
